import { ApiUtil as api } from '@/utils/api.util.js'

export class PlaceService {
  static URL = process.env.API_URL + process.env.API_VER
  static RESOURCE = '/places/'

  static all (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams)
  }
}



// WEBPACK FOOTER //
// ./src/services/place.service.js